import { Component, Input, inject } from '@angular/core';
import { DocumentService } from '@app/services/document.service';
import { LoadingBarService } from '@shared/services/loading-bar.service';

@Component({
  selector: 'lgv-download-table-item',
  template: ` @if (value) {
      <div (click)="onClick()" class="file">{{ value?.name }}</div>
    }
    @if (!value) {
      <div>-</div>
    }`,
  styles: [
    `
      .file {
        text-decoration: underline;
        cursor: pointer;
        word-break: break-word;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    `,
  ],
  standalone: false,
})
export class DownloadTableItemComponent {
  private documentService = inject(DocumentService);
  private loadingBarService = inject(LoadingBarService);

  @Input() value: { id: string; name: string };

  async onClick() {
    this.loadingBarService.isLoading.next(true);
    const response = await this.documentService.getSignedUrl(this.value.id);
    await this.documentService.downloadDocument(response.url, this.value.name);
    this.loadingBarService.isLoading.next(false);
  }
}
